
const config = {
	IP: "http://router.egelberg.se:3000",
	bgColor: "#131E29",
	cardColor: "#1D2A3A",
	tableColor: "#182330",
	triggeredText: "#636B74",
	cardWidth: 360,
	version: "0.9.1"
}

export {config};